export default "__VITE_ASSET__JQlwItk4__"